var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { IconButton } from "../IconButton";
import { Button } from "../Button";
import { BackIcon, ForwardIcon } from "../Icons";
import { paginationStyles as classes } from './styles';
function PaginationItemComponent(props, ref) {
    const { color = 'blue', disabled, isSelected, label, page, type, onPageChange } = props, componentProps = __rest(props, ["color", "disabled", "isSelected", "label", "page", "type", "onPageChange"]);
    switch (type) {
        case 'dots':
            return _jsx("span", { css: classes.dots(color), children: "..." });
        case 'next':
        case 'previous':
            return (_jsx(IconButton, Object.assign({ ref: ref, variant: 'ghost', color: color, size: 'small', onClick: () => {
                    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
                }, disabled: disabled }, componentProps, { component: disabled ? 'button' : componentProps.component, href: disabled ? undefined : componentProps.href, to: disabled ? undefined : componentProps.to, label: label, children: type === 'previous' ? _jsx(BackIcon, {}) : _jsx(ForwardIcon, {}) })));
        default:
            return (_jsx(Button, Object.assign({ ref: ref, variant: 'ghost', color: color, size: 'small', onClick: () => {
                    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
                }, isSelected: isSelected, "aria-current": isSelected ? 'page' : undefined }, componentProps, { "aria-label": label, children: page })));
    }
}
/**
 * A component that renders a pagination item, which can be a page number, previous/next button, or dots.
 *
 * @example
 * <PaginationItem type='page' page={2} label='Go to page 2' />
 */
export const PaginationItem = React.forwardRef(PaginationItemComponent);
